export const masterAdminUids = ["vanilla@1780", "rsqrd@1234"];

export const adminRoles = {
  SUPERADMIN: "SUPERADMIN",
  ADMIN: "ADMIN",
};
